import type { ForwardedRef, ReactNode } from 'react';

import { forwardRef, memo } from 'react';
import { SWRConfig } from 'swr';

import type { SwrProviderProps, SwrProviderRef } from './_.type';

import useSwrProviderHooks from './_.hook';

/** SwrProvider. */
export default memo(
  forwardRef(function SwrProvider(props: SwrProviderProps, ref: ForwardedRef<SwrProviderRef>): ReactNode {
    const { middlewares = [], children } = props;

    const { states } = useSwrProviderHooks(props, ref);

    return (
      <SWRConfig
        value={{
          revalidateOnFocus: false,
          use: states.middlewares.concat(middlewares),
        }}
      >
        {children}
      </SWRConfig>
    );
  }),
);
